import { Fragment, useEffect, useState } from "react";
import "./demandPartner1.css";
import Alert from "react-bootstrap/Alert";
import Select, { components } from "react-select";
import { Tabs, Tab, Form, Row, Col, Table, Modal, Button } from 'react-bootstrap';
// import Tabs from 'react-bootstrap/Tabs';
import API from "../../../services/axiosInstance";
import { getLastMonthRange, loggedInUserDetails, makePageableData, simpleDateFormatter } from "../../utils/helper";
// import { label } from "framer-motion/client";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useTranslation } from "react-i18next";
import Pagination from "../../common_modules/pagination.js";
import { FormLoader, useFormLoader } from "../../common_modules/loader.js";
import { FaRegFileLines, FaDownload } from "react-icons/fa6";
import usePreventMultiClick from "../../utils/SubmitPrevent.js";
// Global Data
const tabLabesls = {
    yesterday: "Yesterday",
    last7: "Last 7 Days",
    lastMonth: "Last Month",
    customDate: "Custom Date",
};

// making column custom order and chiness name need to add any column here add it as well in en.json,cn.json
const columnOrder = [
    { key: "date", label: "DATE" },
    { key: "domain", label: "DOMAIN" },
    { key: "adunit", label: "AD UNIT" },
    { key: "net_request", label: "GAM REQUESTS" },
    { key: "total_request", label: "REQUESTS" },
    { key: "matched_request", label: "MATCHED REQUESTS" },
    { key: "total_impression", label: "IMPRESSIONS" },
    { key: "coverage", label: "COVERAGE (%)" },
    { key: "total_click", label: "CLICKS" },
    { key: "ctr", label: "CTR (%)" },
    { key: "pub_revenue", label: "PUB REVENUE ($)" },
    { key: "pub_ecpm", label: "PUB ECPM ($)" },
    { key: "revenue", label: "REVENUE ($)" },
    { key: "ecpm", label: "ECPM ($)" },
    { key: "pub_fixed_revenue", label: "FIXED REVENUE" },
    { key: "adx_impression", label: "ADX IMPRESSION" },
    { key: "report_type", label: "REPORT TYPE" }
];


const DemandPartner1 = (data) => {
    // global
    const { t, i18n } = useTranslation();
    // const currencyOption = [
    //     { label: t("INR"), value: "1" },
    //     { label: t("USD"), value: "2" },
    //     { label: t("HKD"), value: "3" },
    // ];
    const languageOption = [
        { label: "English", value: "0" },
        { label: t("Chinese"), value: "1" },
        // { label: "Hindi", value: "3" },
    ];

    const [activeTab, setActiveTab] = useState("last7");
    const [lastDate, setLastDate] = useState({
        startDate: simpleDateFormatter(new Date(), -7),
        endDate: simpleDateFormatter(new Date(), -1)
    }); // 7 days date default
    //  table start
    const [domainOptions, setDomainOptions] = useState([]);
    const [selectedDomains, setSelectedDomains] = useState([]);
    const [domainsIds, setDomainIds] = useState([]);
    const [adUnitOptions, setAdUnitOptions] = useState([]);
    const [selectedAdunits, setSelectedAdunits] = useState([]);
    const [adunitsIds, setAdunitsIds] = useState([]);
    const [metricsOptions, setMetricsOptions] = useState([]);
    const [selectedMetrics, setSelectedMetrics] = useState([]);
    const [language, setLanguage] = useState(languageOption[0]);
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [currency, setCurrency] = useState([]);
    const [range, setRange] = useState();

    const [show, setShow] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const [dateDistribution, setDateDistribution] = useState(false);
    const [roundOff, setRoundOff] = useState(true);
    const [reportInfo, setReportInfo] = useState(true);
    const [paginationData, setpaginationData] = useState({});
    const [pageSize, setPageSize] = useState(50);
    const [reportingType, setReportingType] = useState(0);
    const [fixedRevenueType, setFixedRevenueType] = useState(undefined);
    const [paymentType, setPaymentType] = useState(0);
    const [loginUser, setLoginUser] = useState(undefined);
    const [alertMsgMetrics, setAlertMsgMetrics] = useState(new Map());
    const [showPopup, setShowPopup] = useState(false);
    const [dashboardLoader, setDashboardLoader] = useState(false);
    const [invoiceSettingData, setInvoiceSettingData] = useState(true);

    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const [revenueType, setRevenueType] = useState(false);
    const today = new Date();

    const minDate = new Date();
    minDate.setDate(today.getDate() - 70); // last 30 days

    const handleClose = (obj, clear) => {
        setShow(false); // only close modal
        if (clear) {
            setRange(); // with clear data of state
        }
    }

    const handleShow = () => {
        setActiveTab("customDate")
        setShow(true);
    }

    const applyCustomDate = () => {
        handleClose();
        // fire api for cutom date
        let lastDate = {
            startDate: simpleDateFormatter(range.from, 0),
            endDate: simpleDateFormatter(range.to, 0)
        }
        setLastDate(lastDate);
        getReportData(language.value, currency.value, selectedMetrics, lastDate);
    }

    // For domain list
    const allRealOptions = domainOptions.filter((opt) => opt.value !== "");
    const isAllSelected = selectedDomains.length === allRealOptions.length;
    // For adunits list
    const allAdunitOptions = adUnitOptions.filter((unitOpt) => unitOpt.value !== "");
    const allAdunitSelected = selectedAdunits.length === allAdunitOptions.length;

    const handleChange = (selected, name) => {
        const isCorrect = selected?.some((eachObj) => eachObj.value && eachObj.value);

        if (name.toLowerCase() === `domain`.toLowerCase()) {
            if (isCorrect) {
                setSelectedDomains(selected);
                // adUnit api
                getAdUnitList(selected.map((eachObj) => eachObj.value));
            } else {
                setSelectedDomains([]);
                setSelectedAdunits([]);
            }
        } else if (name.toLowerCase() === `adUnit`.toLowerCase()) {
            if (isCorrect) {
                setSelectedAdunits(selected);
            } else {
                setSelectedAdunits([]);
            }
        }

    };

    // Handle on change for checkboxes
    const handleMetricToggle = (metric) => {
        setSelectedMetrics(prev =>
            prev.includes(metric) ? prev.filter(m => m !== metric) : [...prev, metric]
        );
    };
    const handleSelectAllMetrics = () => {
        setSelectedMetrics(selectedMetrics.length === metricsOptions.length ? [] : [...metricsOptions]);
    };

    const getDomainsList = async () => {
        startLoading();
        try {
            const response = await API.get(`/publisher/gam/pub/domain/list`);
            if (response.status === 200) {
                const result = response.data.data;
                const modifiedResult = result.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                // modifiedResult.sort((a, b) => a.label.localeCompare(b.label));
                setDomainOptions(modifiedResult);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const getAdUnitList = async (reqPayload) => {
        startLoading();
        try {
            const response = await API.post(`/publisher/gam/adunits/domain`, reqPayload);
            if (response.status === 200) {
                const result = response.data.data;
                const modifiedResult = result.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                // modifiedResult.sort((a, b) => a.label.localeCompare(b.label));
                setAdUnitOptions(modifiedResult);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const getGamMetrics = async (loginUserInfo, language, currency) => {
        startLoading();
        try {
            if (loginUserInfo) {
                // setLoginUser(loginUserInfo);
                // AccountType: 0 => Admin 1 => Publisher , 2 => Internal User
                let URL = loginUserInfo.accountType == 1 ? `/publisher/account/gam/metrics/list` : `/publisher/gam/metrics`;
                const response = await API.get(URL);
                if (response.status === 200) {
                    const metricsData = response.data.data;
                    setMetricsOptions(metricsData);
                    setSelectedMetrics(metricsData) // when page load then all metrics are selected by default

                    // change laguage and call stats api for update data according language.
                    onChangeLanguage(language, metricsData, currency);
                }
            }
        } catch (error) {

        } finally {
            stopLoading();
        }
    }

    const getReportData = async (language, currency, metricsData, dates, reportdownload = false, pageViewDownload = false, page = 0) => {
        if (btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            let metrics = {};
            let mt = metricsData ? metricsData : selectedMetrics;
            if (mt.length > 0) {
                mt.forEach(m => {
                    metrics[m.metricName] = true;
                });
            }

            const domainIdList = selectedDomains?.map((item) => item.value);
            const adunitsList = selectedAdunits?.map((item) => item.label);

            const payload = {
                round_off_metric: roundOff, // round off checkbox,
                date: dateDistribution, // date distribution checkbox,
                start_date: Object.keys(dates).length > 0 ? dates.startDate : lastDate,
                end_date: Object.keys(dates).length > 0 ? dates.endDate : lastDate,
                domain: domainIdList,
                ad_unit: adunitsList,
                start_index: page,
                page_size: pageSize,
                page_view_download: pageViewDownload, // download csv
                gam_report_download: reportdownload, // download csv
                currency: currency,
                langType: language,
                ...metrics
            };

            const response = await API.post(`/publisher/gam/report/stats`, payload);

            if (response.status === 200) {
                if (reportdownload || pageViewDownload) {
                    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    const fileName = response.headers["file-name"];
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                } else {
                    let result = response.data.data;
                    // reporting panel type

                    setReportingType(result?.reportingType);
                    setPaymentType(result?.paymentType);

                    setFixedRevenueType(result?.fixedRevenueType);
                    // result.data.sort((a, b) => a.label.localeCompare(b.label));
                    setReportInfo(result);

                    // statistics for alert message 
                    let statistics = result.statistics;
                    if (statistics) {
                        statistics.forEach(stats => {
                            if (stats.metricName == "revenue" || stats.metricName == "pub_revenue" || stats.metricName == "pub_fixed_revenue") {
                                setAlertMsgMetrics(prevStats => {
                                    const updated = new Map(prevStats);
                                    updated.set(stats.metricName, true);
                                    return updated;
                                });
                            }

                        });

                        //set revenueType true if metricName contains ->a)pub_fixed_revenue b)revenue c)pub_revenue
                        const isRevenue = result?.headers?.filter((item, b) => {
                            return (item?.metricName === "pub_fixed_revenue" || item?.metricName === "pub_revenue" || item?.metricName === "revenue");
                        });
                        setRevenueType(isRevenue ? true : false);

                    }

                    if (response?.data?.data?.totalCount) {
                        const pageableData = makePageableData(response.data.data.totalCount,
                            payload.page_size, payload.start_index,
                            response?.data?.data?.data.length);
                        setpaginationData(pageableData);
                    } else {
                        setpaginationData("");
                    }
                }


            }
        } catch (error) {

        } finally {
            setBtnClicked(false);
            stopLoading();
            setDashboardLoader(true);
        }
    }

    const onChangeLanguage = (lang, metricsData, selectedCurrency) => {
        setLanguage(lang);
        if (lang.value == 0) {
            i18n.changeLanguage("en");
        } else if (lang.value == 1) {
            i18n.changeLanguage("cn");
        } else if (lang.value == 2) {
            i18n.changeLanguage("hi");
        }

        try {
            getReportData(lang.value, selectedCurrency ? selectedCurrency.value : currency.value, metricsData ? metricsData : selectedMetrics, lastDate);
        } catch (error) {
            console.log(error);
        }
    }

    const onChangeCurrency = (curr) => {
        setCurrency(curr);

        // fetch stats according to selected language
        getReportData(language.value, curr.value, selectedMetrics, lastDate);
    }

    const onClickActiveTabHandler = (tabName) => {
        setActiveTab(tabName)

        let lastDate = {
            startDate: "",
            endDate: ""
        }

        if (tabName == "yesterday") {
            lastDate.startDate = simpleDateFormatter(new Date(), -1);
            lastDate.endDate = simpleDateFormatter(new Date(), -1);
        } else if (tabName == "last7") {
            lastDate.startDate = simpleDateFormatter(new Date(), -7);
            lastDate.endDate = simpleDateFormatter(new Date(), -1);
        } else if (tabName == "lastMonth") {
            const lastMonth = getLastMonthRange();
            lastDate.startDate = lastMonth.startDate;
            lastDate.endDate = lastMonth.endDate;
        }

        setLastDate(lastDate);
        // call api for data
        getReportData(language.value, currency.value, selectedMetrics, lastDate);

    }

    const generateReport = () => {
        getReportData(language.value, currency.value, selectedMetrics, lastDate);

    }

    const downloadCSV = (metricName) => {
        if (window.confirm("do you want to download reporting csv file.")) {
            if (metricName) {
                getReportData(language.value, currency.value, selectedMetrics, lastDate, false, true);
            } else {
                // without metricname
                //download csv via api only mark true 
                getReportData(language.value, currency.value, selectedMetrics, lastDate, true);
            }
        }
    }

    const nextPage = (nextPage) => {
        getReportData(language.value, currency.value, selectedMetrics, lastDate, false, false, nextPage);
    }

    const filteredColumns = columnOrder.filter(col => {
        let a = reportInfo?.data?.some(row => {
            let b = row.hasOwnProperty(col.key);
            return b;
        });
        return a;
    }
    );

    const getCurrenyData = async () => {
        startLoading();
        try {
            const response = await API.get(`/publisher/currency/list/${0}`);
            if (response.status === 200) {
                const result = response.data.data;
                const modifiedResult = result.map(item => ({
                    value: item.id,
                    label: item.currencyCode
                }));
                setCurrencyOptions(modifiedResult);
            }
        } catch (error) { } finally {
            stopLoading();
        }
    }

    const getInvoiceSettingDetails = async (loginUserInfo) => {
        startLoading();
        let currencyObj;
        let languageObj;
        try {
            if (loginUserInfo.accountType == 1) {
                const response = await API.get(`/publisher/invoice/setting/limited/${loginUserInfo.userId}`);
                if (response.status === 200) {
                    const result = response.data.data;
                    setInvoiceSettingData(result);
                    currencyObj = JSON.parse(result.currency);
                    setCurrency(currencyObj);
                    languageObj = languageOption.filter(lang => lang.value == result.language)[0];
                    setLanguage(languageObj);

                    // other fields from invoice setting
                    // setReportingType(result?.reportingType);
                    // setPaymentType(result?.paymentType);
                }

            } else {
                // defualt values for non-publisher user
                currencyObj = { label: "USD", value: "2" };
                languageObj = { label: "English", value: "0" };
                // setReportingType(0);
                // setPaymentType(0);
                setLanguage(languageObj);
                setCurrency(currencyObj);
            }
        } catch (error) { } finally {
            stopLoading();
        }
        // calling other api here after getting default data
        getGamMetrics(loginUserInfo, languageObj, currencyObj);
    }

    const formReturn = (showSubtext, showLogoutBtn, text) => {
        return <FormLoader
            isLoading={true}
            showSubtext={showSubtext}
            showLogoutBtn={showLogoutBtn}
            text={text} />
    }

    useEffect(() => {
        const loginUserInfo = loggedInUserDetails();
        setLoginUser(loginUserInfo);
        getInvoiceSettingDetails(loginUserInfo);
        getCurrenyData();
        getDomainsList();
    }, []);

    useEffect(() => {
        setRange();
    }, [activeTab]);

    useEffect(() => {
        const validSelected = selectedAdunits.filter(item =>
            adUnitOptions.some(option => option.value === item.value)
        );

        if (validSelected.length !== selectedAdunits.length) {
            setSelectedAdunits(validSelected);
        }
    }, [adUnitOptions]);



    console.log(invoiceSettingData);

    return (
        <>
            {/* <FormLoader isLoading={isLoading} text={"Loading..."}> */}
            {invoiceSettingData ?
                <div>
                    <div className="mt-3 dashboard">
                        {/* 1=> publisher, 2=> internal user, 0=> admin */}
                        {
                            (reportingType > 0 && loginUser?.accountType == 1) || (reportingType == 0 && (loginUser?.accountType == 0 || loginUser?.accountType == 2)) ?
                                dashboardLoader ?
                                    <div>
                                        <div className="dasboardTabs">
                                            <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                    <button className={`nav-link ${activeTab === "yesterday" ? "active" : ""}`}
                                                        onClick={() => onClickActiveTabHandler("yesterday")}>
                                                        {t("Yesterday")}
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link ${activeTab === "last7" ? "active" : ""}`}
                                                        onClick={() => onClickActiveTabHandler("last7")}>
                                                        {t("Last 7 Days")}
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link ${activeTab === "lastMonth" ? "active" : ""}`}
                                                        onClick={() => onClickActiveTabHandler("lastMonth")}>
                                                        {t("Last Month")}
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button className={`nav-link ${activeTab === "customDate" ? "active" : ""
                                                        }`} onClick={handleShow}>
                                                        {range ? `(${simpleDateFormatter(range.from, 0).replaceAll("-", "/")} - ${simpleDateFormatter(range.to, 0).replaceAll("-", "/")})` : t("Custom Date")}
                                                    </button>
                                                    {/* modal */}
                                                    <Modal show={show} onHide={() => handleClose(false)} centered size="lg" className="customDate">
                                                        <Modal.Header closeButton>
                                                            <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>{t("Select Date Range")}</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body className="d-flex flex-column align-items-center">
                                                            <DayPicker
                                                                mode="range"
                                                                selected={range}
                                                                onSelect={setRange}
                                                                captionLayout="dropdown"
                                                                numberOfMonths={2}
                                                                pagedNavigation
                                                                showOutsideDays
                                                                // disabled={{
                                                                //     after: new Date(new Date().setDate(new Date().getDate() - 1))
                                                                // }}
                                                                startMonth={minDate}
                                                                endMonth={today}
                                                                defaultMonth={today}
                                                                disabled={{
                                                                    before: minDate,
                                                                    after: today.setDate(today.getDate() - 1)
                                                                }}
                                                            />
                                                            {range && (
                                                                <Button variant="outline-secondary" size="sm" onClick={() => setRange(undefined)} style={{ marginTop: 8 }}>
                                                                    Reset
                                                                </Button>
                                                            )}
                                                        </Modal.Body>
                                                        <Modal.Footer>
                                                            <Button variant="danger" onClick={() => handleClose(true)}>Cancel</Button>
                                                            {range?.from && range?.to && (
                                                                <Button onClick={applyCustomDate} style={{ background: "#0f172a", border: "none" }}>
                                                                    Apply Range
                                                                </Button>
                                                            )}
                                                        </Modal.Footer>
                                                    </Modal>
                                                </li>
                                                {(reportingType != undefined && reportingType == 2) || (loginUser != undefined && loginUser?.accountType != 1) ?

                                                    <li className="nav-item me-3">
                                                        <Select
                                                            key={i18n.language}
                                                            name="language"
                                                            options={languageOption}
                                                            // value={language}
                                                            value={languageOption.find(
                                                                (opt) => opt.value == language.value
                                                            )}
                                                            isSearchable={false}
                                                            closeMenuOnSelect={true}
                                                            placeholder="Language"
                                                            onChange={(sl) => onChangeLanguage(sl)}
                                                            styles={{
                                                                control: (base) => ({ ...base, minHeight: 36 }),
                                                                menu: (base) => ({ ...base, zIndex: 9999 }),
                                                            }} />
                                                    </li>
                                                    : ""}
                                                {
                                                    (paymentType != undefined && paymentType == 2) ||
                                                        (reportingType != undefined && reportingType == 2) ||
                                                        revenueType ||
                                                        // (reportInfo?.headers?.filter((a, b) => a?.metricName === "pub_fixed_revenue")) ||
                                                        (loginUser != undefined && (loginUser?.accountType == 0 || loginUser?.accountType == 2)) ?
                                                        <li className="nav-item">
                                                            <Select
                                                                key={i18n.language}
                                                                name="currency"
                                                                options={currencyOptions?.map(item => ({
                                                                    value: item.value,
                                                                    label: t(item.label)
                                                                }))}

                                                                value={currencyOptions?.map(item => ({
                                                                    value: item.value,
                                                                    label: t(item.label)
                                                                })).find(opt => opt.value == currency.value)}

                                                                isSearchable={false}
                                                                closeMenuOnSelect={true}
                                                                placeholder="Currency"
                                                                onChange={onChangeCurrency}
                                                                styles={{
                                                                    control: (base) => ({ ...base, minHeight: 36 }),
                                                                    menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                }} />
                                                        </li>

                                                        : ""}
                                            </ul>
                                        </div>
                                        {/* Active Tab Label */}
                                        <div className="mt-5 mb-3">
                                            <h5 className="subHead">{t("Showing")}: {t(tabLabesls[activeTab])}</h5>
                                        </div>
                                        {/* Tabs Revenue Data */}
                                        <div className="mt-2 requestData">
                                            <div className="tabsDataRequests">
                                                {
                                                    reportInfo?.statistics?.length > 0 ?
                                                        reportInfo?.statistics.map((item, i) => {
                                                            return (
                                                                <div className="tabsDataChild">
                                                                    {item.metricName.includes("revenue") || item.metricName.includes("ecpm") ?
                                                                        <img src={`/assets/images/${item.metricName}_${currency.value}.png`} />
                                                                        : <img src={`/assets/images/${item.metricName}.png`} />
                                                                    }

                                                                    <div className="tabsTextData">
                                                                        <Row>
                                                                            <Col>
                                                                                <h3 className="tabTitle">{t(item.displayName)}</h3>
                                                                                <span>{item.value}</span>
                                                                            </Col>
                                                                            {item.metricName == "page_views" || item.metricName == "video_page_views" || (item.metricName == "pub_fixed_revenue" && fixedRevenueType != 1 && fixedRevenueType != 2) ? (
                                                                                loginUser?.accountType == 1 && (
                                                                                    <Col className="downloadCSV">
                                                                                        <svg
                                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                                            width="36"
                                                                                            height="36"
                                                                                            viewBox="0 0 24 24"
                                                                                            onClick={() => downloadCSV(item.metricName)}
                                                                                            style={{ cursor: "pointer" }}
                                                                                        >
                                                                                            <title>Download CSV</title>

                                                                                            <circle cx="12" cy="12" r="11" fill="#28a745" />

                                                                                            <path
                                                                                                d="M12 6v7"
                                                                                                stroke="white"
                                                                                                strokeWidth="2.2"
                                                                                                strokeLinecap="round"
                                                                                            />
                                                                                            <path
                                                                                                d="M8.5 10.5L12 14l3.5-3.5"
                                                                                                stroke="white"
                                                                                                strokeWidth="2.2"
                                                                                                strokeLinecap="round"
                                                                                                strokeLinejoin="round"
                                                                                            />
                                                                                            <path
                                                                                                d="M7.5 17h9"
                                                                                                stroke="white"
                                                                                                strokeWidth="2.2"
                                                                                                strokeLinecap="round"
                                                                                            />
                                                                                        </svg>
                                                                                    </Col>
                                                                                )
                                                                            ) : ""
                                                                            }
                                                                        </Row>
                                                                    </div>

                                                                </div>
                                                            );
                                                        })
                                                        : ""
                                                }
                                            </div>
                                        </div>

                                        {/* Alert updates Message */}
                                        {/* "revenue" || "pub_revenue" || "pub_fixed_revenue" */}
                                        {/* {loginUser?.accountType != 1 && ((alertMsgMetrics.get("revenue") || alertMsgMetrics.get("pub_revenue") || alertMsgMetrics.get("pub_fixed_revenue"))) ? */}
                                        {(alertMsgMetrics.get("revenue") || alertMsgMetrics.get("pub_revenue") || alertMsgMetrics.get("pub_fixed_revenue")) ?
                                            <Alert variant="success">
                                                {alertMsgMetrics.get("revenue") &&
                                                    <>
                                                        <p style={{ fontSize: "13px" }}>
                                                            {t("text1")}
                                                        </p>
                                                        <hr />
                                                        <Alert.Heading style={{ fontSize: "12px" }}>
                                                            {t("text2")}
                                                        </Alert.Heading>
                                                    </>
                                                }
                                                {(alertMsgMetrics.get("pub_revenue") || alertMsgMetrics.get("pub_fixed_revenue")) &&
                                                    <Alert.Heading style={{ fontSize: "12px" }}>
                                                        {t("text3")}
                                                    </Alert.Heading>
                                                }
                                                {/* {(loginUser.userId == 1983 || loginUser.userId == 1234) && ( */}
                                                {(loginUser.userId == 1983) && (
                                                    <>
                                                        <Alert.Heading style={{ fontSize: "12px" }}>
                                                            {t("text4")}
                                                        </Alert.Heading>

                                                        <Alert.Heading style={{ fontSize: "12px" }}>
                                                            {t("text5")}
                                                        </Alert.Heading>
                                                    </>
                                                )}
                                            </Alert>
                                            : ""
                                        }

                                        <div className="dimensions">
                                            {/* Dimensions & Metrics */}
                                            {(reportingType != undefined && reportingType == 2) || (loginUser != undefined && loginUser?.accountType != 1) ?
                                                <div>
                                                    <h5 className="mt-5 mb-3 subHead">{t("Dimensions & Metrics")}</h5>
                                                    <Tabs defaultActiveKey="filter" transition={true} id="" className="mb-3">
                                                        <Tab eventKey="filter" title={t("Filters & Dimensions")}>
                                                            <div className="filterTab">
                                                                {/* Domain dropdown start */}
                                                                <div style={{ width: 300, marginRight: 50 }}>
                                                                    <h6 className=" mb-3">{t("Domain")}</h6>
                                                                    <Select
                                                                        name="domain"
                                                                        options={domainOptions}
                                                                        value={selectedDomains}
                                                                        isSearchable={true}
                                                                        onChange={(selected, current) => handleChange(selected, "domain")}
                                                                        isMulti
                                                                        closeMenuOnSelect={false}
                                                                        placeholder="None"
                                                                        styles={{
                                                                            control: (base) => ({ ...base, minHeight: 36 }),
                                                                            menu: (base) => ({ ...base, zIndex: 9999 }),
                                                                        }}
                                                                        components={{
                                                                            MultiValue: ({ index, getValue, ...props }) => {
                                                                                const maxToShow = 3;
                                                                                const values = getValue();

                                                                                if (index < maxToShow) {
                                                                                    return <components.MultiValue {...props} />;
                                                                                }

                                                                                if (index === maxToShow) {
                                                                                    return (
                                                                                        <div style={{ padding: "4px 8px" }}>
                                                                                            +{values.length - maxToShow} more
                                                                                        </div>
                                                                                    );
                                                                                }

                                                                                return null;
                                                                            },
                                                                            // Inlining MenuList so there's only one return in the file:
                                                                            MenuList: (props) => (
                                                                                <div>
                                                                                    <div
                                                                                        style={{
                                                                                            padding: "8px",
                                                                                            borderBottom: "1px solid #ccc",
                                                                                            display: "flex",
                                                                                            justifyContent: "flex-start",
                                                                                        }}
                                                                                    >
                                                                                        <button
                                                                                            type="button"
                                                                                            onClick={() => {
                                                                                                props.selectProps.onChange(
                                                                                                    isAllSelected ? [] : allRealOptions
                                                                                                );
                                                                                            }}
                                                                                            className="buttonAll"
                                                                                            style={{
                                                                                                border: "1px solid #0000003d",
                                                                                                fontSize: "14px",
                                                                                                borderRadius: "2px",
                                                                                            }}
                                                                                        >
                                                                                            {isAllSelected ? `✖ ${t("Deselect All")}` : `✔ ${t("Select All")}`}
                                                                                        </button>
                                                                                    </div>
                                                                                    <components.MenuList {...props}>
                                                                                        {props.children}
                                                                                    </components.MenuList>
                                                                                </div>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </div>
                                                                {/* Ad unit dropdown start */}
                                                                {selectedDomains.length > 0 ?
                                                                    <div className="" style={{ width: 300 }}>
                                                                        <h6 className="mb-3">{t("Ad Unit")}</h6>
                                                                        <Select name="adUnit"
                                                                            options={adUnitOptions}
                                                                            value={selectedAdunits}
                                                                            onChange={(selected, current) => handleChange(selected, "adUnit")}
                                                                            isMulti closeMenuOnSelect={false}
                                                                            placeholder="None" styles={{ control: (base) => ({ ...base, minHeight: 36 }), menu: (base) => ({ ...base, zIndex: 9999 }), }}
                                                                            components={{
                                                                                MultiValue: ({ index, getValue, ...props }) => {
                                                                                    const maxToShow = 3;
                                                                                    const values = getValue();

                                                                                    if (index < maxToShow) {
                                                                                        return <components.MultiValue {...props} />;
                                                                                    }

                                                                                    if (index === maxToShow) {
                                                                                        return (
                                                                                            <div style={{ padding: "4px 8px" }}>
                                                                                                +{values.length - maxToShow} more
                                                                                            </div>
                                                                                        );
                                                                                    }

                                                                                    return null;
                                                                                },
                                                                                MenuList: (props) => (
                                                                                    <div>
                                                                                        <div
                                                                                            style={{
                                                                                                padding: "8px",
                                                                                                borderBottom: "1px solid #ccc",
                                                                                                display: "flex",
                                                                                                justifyContent: "flex-start",
                                                                                            }}>
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => {
                                                                                                    props.selectProps.onChange(
                                                                                                        allAdunitSelected ? [] : allAdunitOptions
                                                                                                    );
                                                                                                }}
                                                                                                className="buttonAll"
                                                                                                style={{
                                                                                                    border: "1px solid #0000003d",
                                                                                                    fontSize: "14px",
                                                                                                    borderRadius: "2px",
                                                                                                }}
                                                                                            >
                                                                                                {allAdunitSelected ? `✖ ${t("Deselect All")}` : `✔ ${t("Select All")}`}
                                                                                            </button>
                                                                                        </div>
                                                                                        <components.MenuList {...props}>
                                                                                            {props.children}
                                                                                        </components.MenuList>
                                                                                    </div>
                                                                                ),
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    : ""}
                                                            </div>
                                                        </Tab>
                                                        {metricsOptions.length > 0 ?
                                                            <Tab eventKey="reporting" title={t("Reporting Metrics")}>
                                                                <div>
                                                                    {/* Info Button */}
                                                                    <i class="fa fa-info-circle" style={{ color: "#4986b5" }} onClick={() => setShowPopup(true)}></i>

                                                                    {/* Modal */}
                                                                    {showPopup && (
                                                                        <div
                                                                            style={{
                                                                                position: "fixed",
                                                                                inset: 0,
                                                                                background: "rgba(0, 0, 0, 0.38)",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center", // center vertically
                                                                                zIndex: 999,
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    width: "95%",
                                                                                    maxWidth: "900px",
                                                                                    background: "#fff",
                                                                                    borderRadius: "4px",
                                                                                    overflow: "hidden",
                                                                                    boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                                                                }}
                                                                            >
                                                                                {/* Header */}
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        padding: "18px 20px",
                                                                                        borderBottom: "1px solid #e5e5e5",
                                                                                    }}
                                                                                >
                                                                                    <h2
                                                                                        style={{
                                                                                            margin: 0,
                                                                                            fontSize: "18px",
                                                                                            fontWeight: "500",
                                                                                            color: "#333",
                                                                                        }}
                                                                                    >
                                                                                        Understanding Metrics Calculation
                                                                                    </h2>

                                                                                    <button
                                                                                        onClick={() => setShowPopup(false)}
                                                                                        style={{
                                                                                            border: "none",
                                                                                            background: "transparent",
                                                                                            fontSize: "30px",
                                                                                            lineHeight: "20px",
                                                                                            cursor: "pointer",
                                                                                            color: "#777",
                                                                                        }}
                                                                                    >
                                                                                        ×
                                                                                    </button>
                                                                                </div>

                                                                                {/* Content */}
                                                                                <div
                                                                                    style={{
                                                                                        padding: "15px 25px",
                                                                                        color: "#333",
                                                                                        fontSize: "16px",
                                                                                    }}
                                                                                >
                                                                                    <ul style={{ margin: 0, paddingLeft: "22px" }}>
                                                                                        <li style={{ marginBottom: "16px" }}>
                                                                                            Pub Revenue = Payout Percentage * GAM Revenue
                                                                                        </li>

                                                                                        <li>
                                                                                            Revenue = Revenue generated on GAM
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                {
                                                                    metricsOptions.length > 1 ?
                                                                        <>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="18"
                                                                                height="18"
                                                                                viewBox="0 0 24 24"
                                                                                fill="#5B9BD5"
                                                                                style={{ cursor: "pointer", verticalAlign: "middle" }}
                                                                                onClick={() => setShowInfo(true)}
                                                                            >
                                                                                <circle cx="12" cy="12" r="10" />
                                                                                <rect x="11" y="10" width="2" height="7" fill="white" />
                                                                                <circle cx="12" cy="7" r="1.3" fill="white" />
                                                                            </svg>
                                                                            <Row>
                                                                                <Col>
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        label={t("Select All")}
                                                                                        // checked={selectedMetrics.length === metricsOptions.length}
                                                                                        checked={selectedMetrics.length === metricsOptions.length}
                                                                                        onChange={handleSelectAllMetrics}
                                                                                        className="mb-3"
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                        </>
                                                                        : ""}
                                                                <Row>
                                                                    {
                                                                        metricsOptions.map((metric, i) => {
                                                                            if (metric.metricName == "page_views" || metric.metricName == "video_page_views") {
                                                                                // skip to render
                                                                            } else {
                                                                                return (
                                                                                    <Col key={i} md={3}>
                                                                                        <Form.Check
                                                                                            type="checkbox"
                                                                                            label={language.value == 1 ? metric.chineseName : metric.displayName}
                                                                                            checked={selectedMetrics.includes(metric)}
                                                                                            onChange={() => handleMetricToggle(metric)}
                                                                                        />
                                                                                    </Col>
                                                                                )
                                                                            }

                                                                        })
                                                                    }
                                                                </Row>
                                                            </Tab>
                                                            : ""}
                                                    </Tabs>

                                                    <div>
                                                        <Row className="my-4 align-items-center">
                                                            <Col xs={6} sm={6} md={3} lg={2}>
                                                                <label className="tabTitle">
                                                                    <div className="form-check-inputform-check d-flex align-items-center gap-2">
                                                                        <input className="form-check-input" checked={dateDistribution} onChange={(e) => setDateDistribution(e.target.checked)} name="dateDistribution" type="checkbox" />
                                                                        <p>{t("Date Distribution")}</p>
                                                                    </div>
                                                                </label>
                                                            </Col>
                                                            <Col xs={6} sm={6} md={3} lg={2}>
                                                                <label className="tabTitle">
                                                                    <div className="form-check-inputform-check d-flex align-items-center gap-2">
                                                                        <input className="form-check-input" checked={roundOff} onChange={(e) => setRoundOff(e.target.checked)} name="roundOff" type="checkbox" />
                                                                        <p>{t("Round Off")}</p>
                                                                    </div>
                                                                </label>
                                                            </Col>
                                                            <Col xs={6} sm={6} md="auto" className="ms-md-auto mt-4 mt-md-0">
                                                                <Button disabled={btnClicked} onClick={generateReport} className="rounded-1 dashBoardBtns"><FaRegFileLines /> {t("Generate Report")}</Button>
                                                            </Col>
                                                            {reportInfo?.data?.length > 0 ?
                                                                <Col xs={6} sm={6} md="auto" className="mt-4 mt-md-0">
                                                                    <Button variant="success" disabled={btnClicked} onClick={() => downloadCSV()} className="rounded-1 dashBoardBtns"><FaDownload /> {t("Download CSV")}</Button>
                                                                </Col>

                                                                : ""}
                                                        </Row>
                                                    </div>
                                                </div>
                                                : ""}


                                            {/* Table */}
                                            <div className="mt-0 table-wrapper mt-3" style={{ overflowX: "auto", maxHeight: "500px" }} >
                                                <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                                                    <thead className="table-light text-center">
                                                        <tr>
                                                            <th className="sticky-col">☰</th>
                                                            {/* {filteredColumns.map((col, i) => {
                                               
                                               return (
                                                    <th key={i}>
                                                        {t(col.label)}
                                                    </th>
                                                )
                                            })} */}
                                                            {reportInfo?.headers?.map((col, i) => {
                                                                return (
                                                                    <th key={i}>
                                                                        {t(col.displayName)}
                                                                    </th>
                                                                )
                                                            })}

                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-center">
                                                        {reportInfo?.data?.length > 0 ? (
                                                            reportInfo.data.map((row, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td className="fw-semibold text-muted">{(paginationData.number * pageSize) + (i + 1)}</td>

                                                                        {reportInfo?.headers?.map((col, j) => {
                                                                            return (
                                                                                <td key={j}>
                                                                                    {row[col.metricName]}
                                                                                </td>
                                                                            )
                                                                        })}
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={reportInfo?.headers?.length + 1} className="text-center py-4 text-muted">
                                                                    {t("No Data Found !!!")}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                            {/* pagination */}
                                            <div className="mt-3">
                                                {reportInfo?.data ?
                                                    Object.keys(paginationData).length > 0 ?
                                                        <Pagination
                                                            jumpPage={true}
                                                            count={true}
                                                            initCall={false}
                                                            component={DemandPartner1.name}
                                                            size={"sm"}
                                                            paginationData={paginationData}
                                                            nextPage={nextPage} />
                                                        : ""
                                                    : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    : formReturn(true, false, "Dashboard Loading...")
                                : dashboardLoader ?
                                    (reportingType == 0) ? <Alert variant="success">No Dashboard Data</Alert> : ""
                                    : formReturn(true, false, "Dashboard Loading...")

                        }
                    </div>

                    {/* Modals  matrix info*/}
                    <Modal show={showInfo} onHide={() => setShowInfo(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {t("Understanding Metrics Calculation")}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                metricsOptions.map((metric, i) => {
                                    if (!metric.metricChineseInfo || !metric.metricInfo) {
                                        return false;
                                    }
                                    return (
                                        <ul key={i}>
                                            <li>
                                                {
                                                    language.value == 1
                                                        ? metric.metricChineseInfo
                                                        : metric.metricInfo
                                                }
                                            </li>
                                        </ul>
                                    )
                                })
                            }
                        </Modal.Body>
                    </Modal>
                </div>
                : formReturn(false, true, `The setup for publisher "${loginUser?.sub}" is not complete yet`)
            }
        </>

    );
}

export default DemandPartner1;
